import { Link } from 'react-router-dom';
import { usePatients } from '../lib/queries';
import Spinner from '../components/Spinner';

export default function Patients() {
  const { data, isLoading, error } = usePatients();

  if (isLoading) return <Spinner />;
  if (error) {
    return (
      <div className="alert alert-danger">
        Erro ao carregar pacientes: {(error as Error).message}
      </div>
    );
  }

  const patients = data ?? [];

  return (
    <div>
      <div className="d-flex justify-content-between align-items-start mb-4">
        <div>
          <h1 className="h3 mb-1">Pacientes</h1>
          <p className="text-muted small mb-0">
            Famílias na waitlist + perfis de demonstração
          </p>
        </div>
      </div>

      <div className="card shadow-sm">
        <div className="list-group list-group-flush">
          {patients.length === 0 && (
            <div className="list-group-item text-muted small py-4 text-center">
              Nenhuma família ainda. Compartilhe o link de convite.
            </div>
          )}
          {patients.map((p) => (
            <Link
              key={p.id}
              to={`/patients/${p.id}`}
              className="list-group-item list-group-item-action d-flex align-items-center gap-3 py-3"
            >
              <div
                className="rounded-circle d-flex align-items-center justify-content-center bg-success bg-opacity-10 flex-shrink-0"
                style={{ width: 44, height: 44, fontSize: '1.25rem' }}
              >
                {p.photo}
              </div>
              <div className="flex-grow-1 min-width-0">
                <div className="fw-semibold">{p.name}</div>
                <div className="small text-muted">
                  {p.age}
                  {p.source === 'waitlist' ? ' · waitlist' : ' · demo'}
                </div>
              </div>
              {p.alert && (
                <span className="badge text-bg-danger rounded-pill">!</span>
              )}
              <i className="bi bi-chevron-right text-muted" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
